import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { paymentStatusSlideUp } from '../../utilities';
import {
  Discount,
  PaymentEntity,
  PaymentStepperNewEvent,
  PaymentTransportationMethod,
  Voucher,
} from 'src/app/shared';
import {
  Address,
  PaymentStatusPreSubmit,
  PAYMENT_COMPS,
  UserSchema,
} from 'src/app/core';
import { ShoppingCartService } from '../../services/shopping-cart.service';

@Component({
  selector: 'payment-navigation',
  styleUrls: ['./payment-navigation.component.sass'],
  templateUrl: './payment-navigation.component.html',

  animations: [paymentStatusSlideUp],
})
export class PaymentNavigationComponent implements OnInit {
  @Input() transportationMethod!: PaymentTransportationMethod;
  @Input() activatedComponent!: PAYMENT_COMPS;
  @Input() isLoading$!: Observable<boolean>;
  @Input() paymentRedirectUrl!: string;
  @Input() payment!: PaymentEntity;
  @Input() discount!: Discount;
  @Input() voucher!: Voucher;
  @Input() user!: UserSchema;
  @Input() address!: Address;

  @Input() isLoggedIn!: boolean;

  @Output('stepper') stepperEvent: EventEmitter<PaymentStepperNewEvent> =
    new EventEmitter();

  public componentsName: string[] = [];
  public paymentComps = PAYMENT_COMPS;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  get paymentStatus$(): Observable<PaymentStatusPreSubmit> {
    return this.shoppingService.paymentStatus$.pipe(
      map((status) => {
        if (!status) {
          return { price: 0, selectedCount: 0 };
        }
        return status;
      })
    );
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private shoppingService: ShoppingCartService
  ) {}

  ngOnInit(): void {}

  nextStep() {
    this.stepperEvent.next({ name: 'next' });
  }

  navigateStep(component: PAYMENT_COMPS) {
    this.stepperEvent.next({ name: 'navigate', payload: component });
  }

  onUserIndicatorChange(user: UserSchema) {
    this.user = user;
  }

  getPricesSum() {
    if (this.payment.isFinalized) {
      return this.payment.amount;
    }

    const pricesSum =
      Number(this.transportationMethod?.valueAdded) +
      Number(this.payment?.amount || 0);

    return this.withDiscount(pricesSum);
  }

  private withDiscount(num: number) {
    if (!this.voucher) return num;

    const discountAmount = (num / 100) * this.voucher.amount;
    const finalPrice = num - discountAmount;

    return finalPrice > 0 ? finalPrice : 0;
  }
}
